
import { defineComponent, ref, reactive, onBeforeMount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { ElMessage } from "element-plus";
import { getHistoryExam, getHistoryMockExam } from "@/services";
import useExam from "@/hooks/useExam";
import useMockExam from "@/hooks/useMockExam";
import { MutationNames, useStore } from "@/store";
export default defineComponent({
  setup() {
    const { getExamPaper, showExamMessageBox } = useExam();
    const { getExamPaper: getMockExamPaper } = useMockExam();
    const _store = useStore();
    let titleTopTxt = ref("");
    let titleTxt = ref("");
    let examThree: any = reactive([]);
    let examList: any = reactive([]);
    let total = ref(1);
    let current_page = ref(1);
    let message = ref("");
    const router = useRouter();
    const route = useRoute();
    const type = route.query.type;
    const goBack = () => {
      if (type === "exam") {
        router.push({
          path: "/examPaperList",
        });
      }
      if (type === "mockExam") {
        router.push({
          path: "/mockExamPaperList",
        });
      }
    };
    const getHistoryMockExamData = () => {
      getHistoryMockExam({ per_page: 8, page: current_page.value }).then(
        (data: any) => {
          // const examData = [];
          examThree.length = 0;
          examThree.push(...data.items);
          titleTxt.value = "暂无模拟测评记录";
          if (data.meta) {
            total.value = data.meta.last_page;
          }
        }
      );
    };
    const getHistoryExamData = () => {
      getHistoryExam({ per_page: 8, page: current_page.value }).then(
        (data: any) => {
          // const examData = [];
          examThree.length = 0;
          examThree.push(...data.items);
          titleTxt.value = "暂无正式测评记录";
          if (data.meta) {
            total.value = data.meta.last_page;
          }
        }
      );
    };

    const goPaper = (exam: any) => {
      const examInfo = {
        active_exam: { id: exam.exam_id, name: exam.exam.name },
        answer_sheet: exam,
      };
      exam.examType = "histroy";
      console.log("exampaper", exam);
      console.log("exampaper1", examInfo);
      _store.commit(MutationNames.CHANGE_EXAMINFO, examInfo);
      if (exam.status === 2 || type === "mockExam") {
        if (type === "mockExam") {
          getMockExamPaper(exam)
            .then(() => {
              console.log("then");
              router.push({
                path: "/mockPaper",
                query: { examType: "histroy" },
              });
            })
            .catch(() => {
              console.log("catch");
            });
        } else {
          getExamPaper(exam, { ignoreLan: true })
            .then(() => {
              console.log("then");
              router.push({
                path: "/paper",
                query: { examType: "histroy" },
              });
            })
            .catch(() => {
              console.log("catch");
            });
        }
      } else {
        ElMessage({
          type: "info",
          center: true,
          message: "待老师阅卷后再查看！",
        });
      }
    };
    const next = () => {
      if (current_page.value === total.value) {
        message.value = "已经是最后一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value++;
        if (type === "exam") {
          getHistoryExamData();
        } else {
          getHistoryMockExamData();
        }
        // examThree.length = 0;
        // const startIndex = current_page.value * 8 - 8;
        // const endIndex = current_page.value * 8;
        // examThree.push(...examList.slice(startIndex, endIndex));
      }
    };
    const previous = () => {
      if (current_page.value === 1) {
        message.value = "已经是第一页";
        ElMessage.warning({
          offset: 100,
          message: message.value,
          type: "warning",
        });
      } else {
        current_page.value--;
        if (type === "exam") {
          getHistoryExamData();
        } else {
          getHistoryMockExamData();
        }

        // examThree.length = 0;
        // const startIndex = current_page.value * 8 - 8;
        // const endIndex = current_page.value * 8;
        // console.log("indexpre", startIndex, endIndex);
        // examThree.push(...examList.slice(startIndex, endIndex));
      }
    };
    onBeforeMount(() => {
      if (type === "exam") {
        titleTopTxt.value = "正式测评记录";
        getHistoryExamData();
      }
      if (type === "mockExam") {
        titleTopTxt.value = "模拟测评记录";
        getHistoryMockExamData();
      }
    });

    return {
      type,
      examThree,
      current_page,
      total,
      titleTxt,
      titleTopTxt,
      goBack,
      next,
      previous,
      goPaper,
    };
  },
});
